var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"homeSlide"},[_c('div',{staticClass:"homeSlide__mask"}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"homeSlide__text"},[_c('p',{staticClass:"homeSlide__title special-title"},[_vm._v(_vm._s(_vm.item.title))]),_c('span',{staticClass:"homeSlide__description"},[_vm._v(_vm._s(_vm.item.desc))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }